"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getClickAndCollectStores = exports.getClickAndCollectStoresOpeningsHours = exports.getStoreInformation = void 0;
const tslib_1 = require("tslib");
const common_types_1 = require("@as-react/common-types");
const axios_1 = tslib_1.__importDefault(require("axios"));
const createUrl_1 = require("../../utils/createUrl");
const common_utils_1 = require("@as-react/common-utils");
const urlMapping = {
    getStoreInformation: {
        client: 'api/store/schedule',
        // server: '/configuration-service/store/openinghours',
    },
    getClickAndCollectStoresOpeningsHours: {
        client: 'api/basket/store/openingshours',
        // server: '/clickandcollect-promise-service/clickandcollect/bu/enriched/openinghours'
    },
    getClickAndCollectStores: {
        client: 'api/store/clickandcollect/',
        // server: '/configuration-service/store/clickandcollect/',
    },
};
const getStoreInformation = (_a, _b) => tslib_1.__awaiter(void 0, [_a, _b], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, { businessUnitId, storeId, weeks = 1 }) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, urlMapping.getStoreInformation, isServer);
    const { market, language, shopId } = defaultRequestParams;
    const axiosConfig = {
        method: 'GET',
        url,
        params: {
            market,
            language,
            businessUnitId,
            fictiveWebShopId: shopId,
            storeId,
            weeks,
        },
    };
    const request = yield axios_1.default.request(axiosConfig);
    return request.data;
});
exports.getStoreInformation = getStoreInformation;
const getClickAndCollectStoresOpeningsHours = (_a, _b) => tslib_1.__awaiter(void 0, [_a, _b], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, { businessUnitId, fictiveShopId, productData, location, onlyInStock, onlyInSpecialtyStore, sortBy, isShopLanding = false, selectedStoreId, }) {
    var _c;
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, urlMapping.getClickAndCollectStoresOpeningsHours, isServer);
    const axiosConfig = {
        method: 'POST',
        url,
        data: {
            market: defaultRequestParams.market,
            businessUnitId,
            mainWebShop: defaultRequestParams.mainWebshop,
            fictiveShopId,
            language: defaultRequestParams.language,
            latitude: location === null || location === void 0 ? void 0 : location.lat,
            longitude: location === null || location === void 0 ? void 0 : location.lng,
            onlyInStock,
            onlyInSpecialtyStore,
            products: productData,
        },
    };
    const request = yield axios_1.default.request(axiosConfig);
    if (((_c = request === null || request === void 0 ? void 0 : request.data) === null || _c === void 0 ? void 0 : _c.length) > 0) {
        const allStores = request.data.filter((store) => store.longitude && store.latitude);
        const firstStore = allStores[0];
        let stores = allStores;
        let sortedStores = stores;
        if (isShopLanding) {
            stores = allStores.slice(1);
        }
        stores = (0, common_utils_1.sortStoresBy)(stores, sortBy, selectedStoreId);
        if (isShopLanding) {
            sortedStores = [firstStore, ...stores];
        }
        return sortedStores;
    }
    return request.data;
});
exports.getClickAndCollectStoresOpeningsHours = getClickAndCollectStoresOpeningsHours;
const getClickAndCollectStores = (_a, _b) => tslib_1.__awaiter(void 0, [_a, _b], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, { location, inStore, allowMultiFascia, sortBy, selectedStoreId }) {
    var _c;
    const cookie = common_utils_1.CookieUtil.get(common_types_1.Cookie.CLICK_AND_COLLECT_STORE);
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, urlMapping.getClickAndCollectStores, isServer, undefined, false);
    const axiosConfig = {
        method: 'GET',
        url,
        params: {
            market: defaultRequestParams.market,
            mainWebShopName: defaultRequestParams.mainWebshop,
            webShopId: defaultRequestParams.shopId,
            allowMultiFasciaClickAndCollect: allowMultiFascia,
            language: defaultRequestParams.language,
            latitude: location.lat,
            longitude: location.lng,
            inStore,
        },
    };
    if (cookie) {
        axiosConfig.params.storeId = cookie;
    }
    const request = yield axios_1.default.request(axiosConfig);
    if (((_c = request === null || request === void 0 ? void 0 : request.data) === null || _c === void 0 ? void 0 : _c.length) > 0) {
        const allStores = request.data.filter((store) => store.longitude && store.latitude);
        return (0, common_utils_1.sortStoresBy)(allStores, sortBy, selectedStoreId);
    }
    return request.data;
});
exports.getClickAndCollectStores = getClickAndCollectStores;
//# sourceMappingURL=store.api.js.map